module.exports = __webpack_public_path__ + "img/26.b935777e.jpg";